import React, { Component, Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SaayaLogo from '../../static/images/default_BG.png';
import AlfalahLogo from '../../static/images/alfalahlogo.png';
import PakQatarLogo from '../../static/images/pakqatarlogo.png';
import KTLogo from '../../static/images/kt-logo.png';
import { authActions, alertActions, counsellorActions } from '../../store/actions';
import { history } from '../../helpers/history';
import Swal from 'sweetalert2';
import { WhitelabelActions } from '../../store/actions';
import { constants } from '../../Constants';
import saayaLogo from '../../static/images/saaya_logo.png';
import { headerMenu } from '../../helpers/ConstantID';
import myCousellorIcon from "../../static/images/my_counselor.svg"
import multiCousellorIcon from "../../static/images/HamburgerIcons/Well-being-nutritionist.svg";
import changePasswordIcon from "../../static/images/HamburgerIcons/Change-password.svg";
import familyMemberIcon from "../../static/images/HamburgerIcons/Add-family-member.svg";
import logoutIcon from "../../static/images/logout.svg"
import wellbeingIcon from '../../static/images/HamburgerIcons/Well-being.svg';
import nutritionistIcon from '../../static/images/HamburgerIcons/Nutritionist.svg';
import pastSessionsIcon from '../../static/images/HamburgerIcons/Past-sessions.svg';
import myPatientIcon from '../../static/images/HamburgerIcons/My-clients.svg';

const defaultImage = lazy(() => import('../../static/images/default_BG.png'));
const Image = lazy(() => import('../../components/Image/index'));
class HeaderComponent extends Component {
	constructor() {
		super();
		this.state = {
			anchorEl: null,
			toggleMenu: false,
		};
		this.dropdownParentRef = React.createRef();
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.addFamilyMember = this.addFamilyMember.bind(this);
	}
	textInput = null;

	componentDidMount() {
		this.props.fetchWhitelabel();
		this.focusDiv();
		document.addEventListener("mousedown", this.handleClickOutside);
		this.props.getMultiCounsellor()
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	handleClickOutside(event) { // detect click outside of dropdown
		if (this.dropdownParentRef && !this.dropdownParentRef.current.contains(event.target)) {
			this.setState({toggleMenu: false})
		}
	}

	componentDidUpdate() {
		this.focusDiv();
	}

	home = () => {
		this.props.user.role === 1
			? history.replace('/home')
			: this.props.user.role === 0
				? history.replace('/home/counsellor')
				: history.replace('/not-found');
	};
	SignOut = () => {
		history.replace('/');
		this.props.logout();
	};

	openMyCounsellor = () => {
		history.push('/my-counsellor');
	};

	openSessions = () => {
		history.push('/sessions-history');
	};

	openMyPatient = () => {
		history.push('/my-patients');
	};

	changePassword = async () => {
		this.setState({
			anchorEl: null,
		});
		const { value: formValues } = await Swal.fire({
			title: 'Change Password',
			showCancelButton: true,
			confirmButtonText: 'Change Password',
			cancelButtonText: `Cancel`,
			confirmButtonColor: '#309583',
			cancelButtonColor: '#C62E2E',
			html:
				'<input id="swal-input1" type="password" placeholder="Old Password" class="swal2-input">' +
				'<input id="swal-input2" type="password" placeholder="New Password" class="swal2-input">' +
				'<input id="swal-input3" type="password" placeholder="Confirm Password" class="swal2-input">' +
				'',
			focusConfirm: false,
			type: 'info',
			reverseButtons: true,

			preConfirm: () => {
				return [
					document.getElementById('swal-input1').value,
					document.getElementById('swal-input2').value,
					document.getElementById('swal-input3').value,
				];
			},
		});

		if (formValues) {
			const data = formValues;
			const { dispatch } = this.props;
			if (data[0] === '' || data[1] === '' || data[2] === '') {
				Swal.fire({
					type: 'error',
					title: 'Saaya Health',
					text: 'Please fill all the fields!',
				});
			} else {
				if (data[1] === data[2]) {
					this.props.changePassword(data[0], data[2]);
				} else {
					Swal.fire({
						type: 'error',
						title: 'Wrong Password',
						text: 'Please enter same password in both fields!',
					});
				}
			}
		}
	};

	addFamilyMember() {
		const { history, location,user } = this.props;
		const isAddFamilyMemberAllowed =  user && user.projects && user.projects[0] && user.projects[0].is_add_family_member_allowed;
		if(!isAddFamilyMemberAllowed){
			 Swal.fire({
				icon:'error',
                title: constants.ADD_FMAILY_MEMBER_TXT,
                text: constants.ADD_FAMILY_MEMBER_ALLOWED_TXT,
                confirmButtonText: constants.OK_TXT,
            });
			return;
		}
		// Check if the current route is the same as the target route
		if (location.pathname !== '/family_member') {
			history.push('/family_member');
		}
	}

	handleClick = (event) => {
		this.setState({
			anchorEl: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorEl: null,
		});
	};

	setToggleMenu = () => {
		this.setState({
			toggleMenu: !this.state.toggleMenu,
		});
	};
	setActive = () => {
		this.setState({ toggleMenu: false });
	};
	focusDiv() {
		if (this.textInput) this.textInput.focus();
	}
	setTextInputRef = (element) => {
		this.textInput = element;
	};
	render() {
		let user_info = localStorage.getItem('user');
		let relation = user_info ? JSON.parse(user_info).has_relation : ''; //this.SignOut();
		let role = user_info ? JSON.parse(user_info).role : null;
		const { user, whitelabel } = this.props;
		const isIBA = whitelabel && whitelabel[0] && whitelabel[0].name && whitelabel[0].name.toLowerCase().indexOf('iba') > -1;
		const { anchorEl } = this.state;
		const _full_name = user_info ? JSON.parse(user_info).full_name : '';
		const initials = user_info
			? String(_full_name)
				.split(' ')
				.map((a) => {
					return a.charAt(0).toUpperCase();
				})
			: '';

		const open = Boolean(anchorEl);
		const { multiCounsellor } = this.props;
		const isMultiCounsellor = Array.isArray(multiCounsellor) && multiCounsellor.length > 1;
		const counsellorType = !isMultiCounsellor && multiCounsellor && multiCounsellor[0] &&
			multiCounsellor[0].service_type ? multiCounsellor[0].service_type.name : null;
		const counsellorIconUrl = isMultiCounsellor
			? multiCousellorIcon
			: counsellorType === 'Wellbeing'
				? wellbeingIcon
				: counsellorType === 'nutritionist'
					? nutritionistIcon
					: myCousellorIcon;	
					
		return (
			<div className={`sh-header-comp ${isIBA && 'mb45'}`}>
				<div className="sh-header-inner">
					<div className="sh-header-left">
						<div className="sh-hl-logo">
							{whitelabel && whitelabel[0].logo_url ?
								<img
								src={whitelabel[0].logo_url }
									alt="SaayaLogo"
									onClick={this.home}
									id="sh_cl_pt_logo"
								/> : ''}
						</div>
					</div>

					<div className="sh-header-right">
						<div className="sh-hr-inner">
							<div className="sh-hri-left">
								<span>{initials}</span>
							</div>
							<div ref={this.dropdownParentRef} className="sh-hri-right">
								<span
									id={`${
										relation !== null && relation !== false
											? role === 1
												? `${headerMenu.sh_pt_profile}`
												: `${headerMenu.sh_cl_profile}`
											: 'sh_pt_unrelated'
										}`}
									className="sh-hri-r-name"
									onClick={this.setToggleMenu}
									onBlur={this.setActive}
									ref={this.setTextInputRef}
								>
									{user_info ? JSON.parse(user_info).full_name : ''}
								</span>
								<ul className={`sh-hri-menu ${this.state.toggleMenu && 'sh-active-menu'}`}>
									{relation !== null && relation !== false ? (
										role === 1 ? (
											<li>
												<span
													onClick={this.openMyCounsellor}
													id={headerMenu.sh_pt_mycounsellor}
												>
													<img
														className={`mr-1 ${isMultiCounsellor ? 'sh-multi-counsellor-icon' : ''}`}
														src={counsellorIconUrl}
														alt="Counsellor Icon"
													/>
													My{' '}
													{whitelabel && whitelabel[0]
														? `${whitelabel[0].producer_role}s`
														: `${constants.COUNSELLOR}s`}
												</span>
											</li>
										) : (
											<li>
												<span onClick={this.openMyPatient} id={headerMenu.sh_cl_mypatient}>
													<img
														className='my-patient-icon mr-1'
														src={myPatientIcon}
														alt="My Patient Icon"
													/>
													My{' '}
													{whitelabel && whitelabel[0]
														? `${whitelabel[0].consumer_role}s`
														: `${constants.STUDENT}s`}
												</span>
											</li>
										)
									) : null}
									{this.props.user && this.props.user.role === 0 ?
										<li>
											<span
												onClick={this.openSessions}
												id={headerMenu.sh_pt_mycounsellor}
											>
												<img
													className='past-sessions-icon mr-1'
													src={pastSessionsIcon}
													alt="Past Sessions Icon"
												/>
												{constants.PAST_SESSIONS}
											</span>
										</li>: ''
									}
									{this.props.user && this.props.user.role === 1 && this.props.user.parent_id === null ?
										<li>
											<span
												onClick={this.addFamilyMember}
												id={`${relation !== null && relation !== false
													? role === 1
														? `${headerMenu.sh_pt_familyMember}`
														: `${headerMenu.sh_cl_familyMember}`
													: 'sh_unrelated_add_familyMember'
													}`}
											>
												<img src={familyMemberIcon} className='mr-1'/>

												{constants.VIEW_FMAILY_MEMBER_TXT}
											</span>
										</li> : ''
									}
									<li>
										<span
											onClick={this.changePassword}
											id={`${
												relation !== null && relation !== false
													? role === 1
														? `${headerMenu.sh_pt_chng_password}`
														: `${headerMenu.sh_cl_chng_password}`
													: 'sh_unrelated_chng_password'
												}`}
										>
											<img src={changePasswordIcon} className='mr-1'/>

											{constants.CHANGE_PASSWORD_TXT}
										</span>
									</li>
									<li>
										<span
											onClick={this.SignOut}
											id={`${
												relation !== null && relation !== false
													? role === 1
														? `${headerMenu.sh_pt_logout}`
														: `${headerMenu.sh_cl_logout}`
													: 'sh_gnrl_logout'
												}`}
										>
											<img src={logoutIcon} className='mr-1'/>
											{constants.LOGOUT_TXT}
										</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				{isIBA && <div className="currentViewStatusDiv">
					<span className="currentViewStatusText">Saaya health has stopped our services at request of IBA management as we work with IBA on a new overhaul. Email us at <a
						data-content="contact@saayahealth.com"
						href="mailto:contact@saayahealth.com"
						data-type="mail"
						className="banner-text-a"
					>
						contact@saayahealth.com
					</a> if you want help or more information.</span>

				</div>
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const { users, auth } = state;
	const { whitelabel } = state.whitelabel;
	const { user } = auth;
	const { multiCounsellor } = state.counsellorStatus;
	return {
		alert,
		user,
		whitelabel,
		users,
		multiCounsellor
	};
}

function mapDispatchToProps(dispatch) {
	return {
		fetchWhitelabel: () => {
			dispatch(WhitelabelActions.fetchWhitelabel());
		},
		logout: () => {
			dispatch(authActions.logout());
		},
		getMultiCounsellor: () => {
			dispatch(
				counsellorActions.getMultiCounsellor()
			);
		},
		changePassword: (data1, data2) => {
			dispatch(authActions.changePassword(data1, data2));
		},
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/components/Header/index.js